import { mix, useCanvasLoop } from "@/components/canvasLoop";

const SAND = { bg: "#E6DFD2", line: [107, 96, 85], accent: [158, 74, 43] };
const SCAR = -0.65;

const drawFrame = (ctx, w, h, t) => {
  ctx.fillStyle = SAND.bg;
  ctx.fillRect(0, 0, w, h);
  const mobile = w < 640;
  const cx = mobile ? w * 0.55 : w * 0.7;
  const cy = mobile ? h * 0.3 : h * 0.52;
  const rMax = Math.hypot(w, h) * (mobile ? 0.6 : 0.55);
  const count = mobile ? 26 : 34;
  for (let k = 0; k < count; k++) {
    const p = ((k + t * 0.18) % count) / count;
    const r = p * rMax;
    if (r < 4) continue;
    const alpha = Math.min(1, p * 8) * (1 - Math.pow(p, 2));
    const glow = Math.exp(-Math.pow((p - 0.28) / 0.12, 2));
    const [cr, cg, cb] = mix(SAND.line, SAND.accent, glow);
    const dent = 26 * Math.exp(-p * 2.4);
    const seed = k + Math.floor((k + t * 0.18) / count) * 7.3;
    ctx.beginPath();
    for (let a = 0; a <= 360; a += 3) {
      const th = (a / 180) * Math.PI;
      let d = th - SCAR;
      d = Math.atan2(Math.sin(d), Math.cos(d));
      const wobble = 1 + 0.035 * Math.sin(3 * th + seed * 0.7) + 0.02 * Math.sin(5 * th - seed * 0.4 + t * 0.15);
      const rr = r * wobble - dent * Math.exp(-Math.pow(d / 0.28, 2));
      const x = cx + Math.cos(th) * rr;
      const y = cy + Math.sin(th) * rr;
      if (a === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
    }
    ctx.closePath();
    ctx.strokeStyle = `rgba(${cr},${cg},${cb},${(0.22 + glow * 0.5) * alpha})`;
    ctx.lineWidth = 1;
    ctx.stroke();
  }
};

export const RingsCanvas = () => {
  const ref = useCanvasLoop(drawFrame);
  return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" data-testid="hero-rings-canvas" />;
};
